export enum TopUpViews {
    general = 'general',
    confirm = 'confirm',
    pending = 'pending',
    success = 'success',
    error = 'error',
    noCards = 'noCards',
}
